import styled from 'styled-components';
import { DEVICES } from '../../config/appConfig';

export const StyleClientCarousel = styled.div`
  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
  /* margin-top: 60px;
  margin-bottom: 40px; */
  .ClientBox {
    max-width: 1140px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
  }
  .ClientBox .ClientLogoBox {
    width: calc(calc(100% - 0px) / 6);
    box-sizing: border-box;
    color: #000;
    text-align: center;
    padding: 15px;
    margin: 0px;
  }
  .ClientBox .ClientLogoBox img {
    width: 100%;
    padding: 2px 8px;
    box-shadow: 0px 0px 4px #00000020;
  }
  @media ${DEVICES.tablet} {
    .ClientBox .ClientLogoBox {
      width: calc(calc(100% - 0px) / 5);
    }
  }
  @media ${DEVICES.mobile} {
    .ClientBox .ClientLogoBox {
      width: calc(calc(100% - 0px) / 5);
    }
  }
  @media ${DEVICES.sMobile} {
    .ClientBox .ClientLogoBox {
      width: calc(calc(100% - 0px) / 3);
    }
  }
`;
